import type { ProductKeys } from '../constants/product-keys';

export const getProductOrder: (
	a: ProductKeys,
	b: ProductKeys,
	productsOrder: ProductKeys[],
) => number = (a: ProductKeys, b: ProductKeys, productsOrder: ProductKeys[]) => {
	const indexA = productsOrder.indexOf(a);
	const indexB = productsOrder.indexOf(b);

	if (indexA === -1 || indexB === -1) {
		return 0;
	} else {
		return indexA - indexB;
	}
};
